import * as permissions from "./permissions";

export const INIT = 0;
export const PICKUPED_FROM_CUSTOMER = 1;
export const ACCEPTED = 2;
export const EDITED = 3;
export const DC_PROCESSED = 4;
export const PICKUP_FROM_CUSTOMER = 5;
export const OFFLOAD_TO_CUSTOMER = 6;
export const OFFLOADED_TO_CUSTOMER = 7;
export const DC_PROCESSING = 8;
export const EDDITED_BY_DC = 9;
export const ERROR = 10;
export const CANCELLED = 11;
export const INTERMEDIATE_POINT = 12;
export const ON_RECEIVING_POINT = 13;
export const PICKUP_TO_DC = 14;
export const PICKUP_TO_RECEIVING_POINT = 15;
export const DC_PROCESSED_RECEIVING_POINT = 16;
export const OFFLOADED_TO_RECEIVING_POINT = 17;
export const COMPLEATED = 18;
export const RECEIVING_POINT_PROCESSING = 19;

export const COURIER_ORDER_TYPE = 0;
export const RECEIVING_POINT_ORDER_TYPE = 1;

export const states = [
    { Id: INIT, Name: "Создан", Type: COURIER_ORDER_TYPE },
    { Id: PICKUPED_FROM_CUSTOMER, Name: "Забрал вещи у клиента", Type: COURIER_ORDER_TYPE },
    { Id: ACCEPTED, Name: "Подтвержден", Type: COURIER_ORDER_TYPE },
    { Id: EDITED, Name: "Отредактирован", Type: COURIER_ORDER_TYPE },
    { Id: DC_PROCESSED, Name: "Заказ обработан технологом", Type: COURIER_ORDER_TYPE },
    { Id: PICKUP_FROM_CUSTOMER, Name: "Курьер выехал за заказом", Type: COURIER_ORDER_TYPE },
    { Id: OFFLOAD_TO_CUSTOMER, Name: "Заказ отправлен клиенту", Type: COURIER_ORDER_TYPE },
    { Id: OFFLOADED_TO_CUSTOMER, Name: "Заказ доставлен клиенту", Type: COURIER_ORDER_TYPE },
    { Id: DC_PROCESSING, Name: "Заказ на производстве", Type: COURIER_ORDER_TYPE },
    { Id: EDDITED_BY_DC, Name: "Корректировка заказа технологом", Type: COURIER_ORDER_TYPE },
    { Id: ERROR, Name: "Ошибка", Type: COURIER_ORDER_TYPE },
    { Id: CANCELLED, Name: "Заказ отменен", Type: COURIER_ORDER_TYPE },
    { Id: INTERMEDIATE_POINT, Name: "Промежуточная точка", Type: COURIER_ORDER_TYPE },
    { Id: ON_RECEIVING_POINT, Name: "Заказ в пункте приема", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: PICKUP_TO_DC, Name: "Заказ отправлен на производство", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: PICKUP_TO_RECEIVING_POINT, Name: "Заказ отправлен в пункт приема", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: DC_PROCESSED_RECEIVING_POINT, Name: "Обработан технологом(для пп)", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: OFFLOADED_TO_RECEIVING_POINT, Name: "Заказ доставлен на пп", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: COMPLEATED, Name: "Заказ выполнен", Type: RECEIVING_POINT_ORDER_TYPE },
    { Id: RECEIVING_POINT_PROCESSING, Name: "Заказ на производстве(для пп)", Type: RECEIVING_POINT_ORDER_TYPE }
];

// statuses which operator can use to update the order
export const operatorEditStates = [ACCEPTED, 
    EDITED, 
    DC_PROCESSED, 
    DC_PROCESSING, 
    EDDITED_BY_DC, 
    CANCELLED, 
    INTERMEDIATE_POINT];
export const receivingPointEditStates = [PICKUP_TO_RECEIVING_POINT, 
    DC_PROCESSED_RECEIVING_POINT, 
    OFFLOADED_TO_RECEIVING_POINT, 
    COMPLEATED,
    PICKUP_TO_DC,
    RECEIVING_POINT_PROCESSING,
    EDDITED_BY_DC,
    ON_RECEIVING_POINT];

export const editStates = [
    {
        Role: permissions.OPERATOR,
        Statuses: [{
            Type: COURIER_ORDER_TYPE,
            Statuses: [ACCEPTED,
                EDITED,
                DC_PROCESSED,
                DC_PROCESSING,
                EDDITED_BY_DC,
                CANCELLED,
                INTERMEDIATE_POINT
            ]
        },
        {
            Type: RECEIVING_POINT_ORDER_TYPE,
            Statuses: [RECEIVING_POINT_PROCESSING,
                DC_PROCESSED_RECEIVING_POINT,
                EDDITED_BY_DC,
            ]
        }
        ],
    },
    {
        Role: permissions.RECEPTION_POINT,
        Statuses: [{
            Type: COURIER_ORDER_TYPE,
            Statuses: []
        },
        {
            Type: RECEIVING_POINT_ORDER_TYPE,
            Statuses: [
                PICKUP_TO_RECEIVING_POINT,
                OFFLOADED_TO_RECEIVING_POINT,
                COMPLEATED,
                PICKUP_TO_DC,
                ON_RECEIVING_POINT
            ]
        }]
    },
    {
        Role: permissions.ADMIN,
        Statuses: [{
            Type: COURIER_ORDER_TYPE,
            Statuses: [
                ACCEPTED,
                EDITED,
                DC_PROCESSED,
                DC_PROCESSING,
                EDDITED_BY_DC,
                CANCELLED,
                INTERMEDIATE_POINT
            ]
        },
        {
            Type: RECEIVING_POINT_ORDER_TYPE,
            Statuses: [
                RECEIVING_POINT_PROCESSING,
                PICKUP_TO_RECEIVING_POINT,
                DC_PROCESSED_RECEIVING_POINT,
                OFFLOADED_TO_RECEIVING_POINT,
                COMPLEATED,
                PICKUP_TO_DC,
                EDDITED_BY_DC,
                ON_RECEIVING_POINT
            ]
        }]
    }
];

export function getEditOrderStates(orderType) {
    const role = permissions.getRole();
    return editStates.find(es => es.Role == role).Statuses.find(s => s.Type == orderType).Statuses;
}

export const operatorAllStates = [INIT,
    PICKUPED_FROM_CUSTOMER,
    ACCEPTED,
    EDITED,
    DC_PROCESSED,
    PICKUP_FROM_CUSTOMER,
    OFFLOAD_TO_CUSTOMER,
    OFFLOADED_TO_CUSTOMER,
    DC_PROCESSING,
    ERROR,
    CANCELLED,
    INTERMEDIATE_POINT,
    PICKUP_TO_RECEIVING_POINT, 
    DC_PROCESSED_RECEIVING_POINT, 
    OFFLOADED_TO_RECEIVING_POINT, 
    COMPLEATED,
    PICKUP_TO_DC,
    EDDITED_BY_DC,
    ON_RECEIVING_POINT];
export const receivingPointOrdersStates = [
    EDDITED_BY_DC,
    RECEIVING_POINT_PROCESSING,
    PICKUP_TO_DC,
    DC_PROCESSED_RECEIVING_POINT
];
export const highlightStates = [INIT, EDDITED_BY_DC, EDITED];
export const cancelDeliveryStates = [DC_PROCESSED, OFFLOAD_TO_CUSTOMER];
export const urgentStates = [INIT, EDDITED_BY_DC, ERROR];
export const deliveryStates = [PICKUPED_FROM_CUSTOMER, ACCEPTED, DC_PROCESSED, PICKUP_FROM_CUSTOMER, OFFLOAD_TO_CUSTOMER];
export const processedStates = [PICKUPED_FROM_CUSTOMER, DC_PROCESSING, DC_PROCESSED, EDDITED_BY_DC];
export const doneStates = [OFFLOADED_TO_CUSTOMER, COMPLEATED];
export const deliveryReceivingPointStates = [PICKUP_TO_DC, PICKUP_TO_RECEIVING_POINT];

export const defaultHighlightColor = "#87CEFA";
export const presetHighlightColors = [
    '#000000',
    '#B5B5B5',
    '#FFFFFF',
    '#FF9D03',

    '#FBFF00',
    '#4582DE',
    '#0105F7',
    '#DD7E6A',

    '#F6CE9B',
    '#A4C2F4',
    '#CA402C',
    '#E46367',

    '#FCD865',
    '#6DA9DA',
    '#A51500',
    '#C50300',

    '#F2C12B',
    '#3179DF',
    '#3C85C9',
    '#6450A7',

    '#A54D7B',
    '#9A0002',
    '#C38E06',
    '#0F4D58',

    '#0C508E',
    '#771A47',
    '#7D5F04',
    '#274F12'
];


// WEBPACK FOOTER //
// ./src/constants/orderStates.js